import { gql } from "@apollo/client";

export const GET_JUSTIFICAR_MINUTA_CONEXIONES = gql`
    query GetConexionesEvaluacionMinutaByIdPendiente($idPendiente: Int!) {
        conexionesEvaluacionMinutaByIdPendiente(idPendiente: $idPendiente) {
            idConexion,
            fechaConexion,
            justificacion,
            color
        }
    }
`;

export const adaptJustificarMinutaConexion = (minuta) => {
  return {
    idConexion: minuta?.idConexion,
    fechaConexion: minuta?.fechaConexion,
    justificacion: minuta?.justificacion,
    color: minuta?.color
  };
};

export const adaptJustificarMinutaConexionArray = (minutas) => {
  return structuredClone(minutas)?.
  map((minuta) => adaptJustificarMinutaConexion(minuta));
};